/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Engine_LabelInputs */



/**
* | output |
* | --- |
* | "Spell check engine selection" |
*
* @param {Spellcheck_Engine_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_engine_label = /** @type {((inputs?: Spellcheck_Engine_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Engine_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selection du moteur de verification orthographique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auswahl der Rechtschreibprüfung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezione del motore di controllo ortografico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбор механизма проверки орфографии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selección del motor de corrección ortográfica")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拼写检查引擎选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スペルチェックエンジンの選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तनी जाँच इंजन का चयन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("seleção do mecanismo de verificação ortográfica")
	return /** @type {LocalizedString} */ ("Spell check engine selection")
});